import React, { useState } from 'react';
import { STRIPE_PAYMENT_LINKS } from '../config';

const Paywall = ({ user, onLogout }) => {
  const [loading, setLoading] = useState(null);

  const handleCheckout = (plan) => {
    setLoading(plan);
    try {
      // Use direct Stripe Payment Links to bypass backend API key issues
      const paymentUrl = plan === 'monthly' 
        ? STRIPE_PAYMENT_LINKS.MONTHLY 
        : STRIPE_PAYMENT_LINKS.ANNUAL;
      
      // Add user email as prefilled parameter for better UX
      const urlWithEmail = user?.email 
        ? `${paymentUrl}?prefilled_email=${encodeURIComponent(user.email)}`
        : paymentUrl;
      
      window.location.href = urlWithEmail;
    } catch (err) {
      alert('Failed to start checkout. Please try again.');
      setLoading(null);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 to-teal-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-xl p-8 max-w-lg w-full text-center">
        <div className="text-6xl mb-6">🔒</div>
        <h1 className="text-3xl font-bold text-gray-900 mb-4">Choose Your Plan</h1>
        <p className="text-gray-600 mb-8">
          Hi {user?.name || 'there'}! Start your journey with Daily Discipline.
        </p>

        <div className="space-y-4">
          <button
            onClick={() => handleCheckout('monthly')}
            disabled={loading}
            className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white font-semibold py-4 rounded-lg transition disabled:opacity-50"
          >
            {loading === 'monthly' ? 'Loading...' : 'Monthly Plan - $7/month'}
          </button>
          <button
            onClick={() => handleCheckout('annual')}
            disabled={loading}
            className="block w-full bg-white border-2 border-emerald-600 text-emerald-600 hover:bg-emerald-50 font-semibold py-4 rounded-lg transition disabled:opacity-50"
          >
            {loading === 'annual' ? 'Loading...' : 'Annual Plan - $49/year (Save 40%)'}
          </button>
        </div>

        <button
          onClick={onLogout}
          className="mt-8 text-gray-500 hover:text-gray-700 text-sm"
        >
          Sign out
        </button>
      </div>
    </div>
  );
};

export default Paywall;
